module.exports = __webpack_public_path__ + "71c531857a0697ea00b0b6fcf5327a4a.svg";